import { PjeOffice } from '@/lib/pjeoffice-pro';
import BusinessError from '../util/BusinessError';
import Api from './Api';

export default class AssinaturaApi extends Api {
    async validarInstalacaoShodo() {
        const urlStatusShodo = 'https://localhost:9000/status/logs';

        const resposta = await fetch(urlStatusShodo, {
            method: 'GET'
        })
            .then(function (response) {
                if (response.ok) {
                    console.info('Assinador digital Shodō disponível.');
                    return true;
                } else {
                    console.info(`Assinador digital Shodō inacessível (HTTP code: ${response.status}).`);
                    return false;
                }
            })
            .catch(function (error) {
                console.info(`Assinador digital Shodō inacessível (${error.message}).`);
                return false;
            });

        return resposta;
    }

    async validarInstalacaoPJeOfficePro() {
        const resposta = await new Promise((resolve) => {
            const apiContext = {
                argument: {
                    REQUEST_TIMEOUT: 5000
                },
                onSuccess: function (data) {
                    resolve({
                        disponivel: data?.success === true
                    });
                },
                onUnavailable: function (statusText) {
                    const mensagem =
                        typeof statusText === 'string' ? statusText : statusText?.statusText || statusText?.status;

                    resolve({
                        disponivel: false,
                        erro: mensagem
                    });
                }
            };

            PjeOffice.ping(apiContext);
        });

        if (resposta.disponivel) {
            console.info('PJeOffice Pro instalado e acessível.');
        } else {
            console.warn(
                'PJeOffice Pro indisponível ou não instalado. Status: ' + (resposta.erro || 'STATUS DESCONHECIDO')
            );
        }

        return resposta.disponivel === true;
    }

    async enviarPedidoAssinaturaHashesShodo(hashes) {
        const url = 'https://localhost:9000/assinarHash';
        let response;

        try {
            response = await fetch(url, {
                method: 'POST',
                body: JSON.stringify(hashes)
            });
        } catch (error) {
            console.error(error);
            throw new Error(
                `Ocorreu um erro ao assinar. Verifique se o Shodō foi instalado e inicializado corretamente e se o certificado digital está operacional.`,
                { cause: error }
            );
        }

        if (response.status === 500) {
            const texto = await response.text();

            if (texto === 'Ocorreu um erro inesperado: Ação cancelada pelo usuário') {
                throw new BusinessError('Ação cancelada pelo usuário');
            } else {
                throw new Error('Ocorreu um erro ao assinar com Shodō');
            }
        }

        return response ? response.json() : null;
    }

    async enviarPedidoAssinaturaP7sShodo(pdfBase64) {
        const url = 'https://localhost:9000/assinarP7s';

        try {
            const response = await fetch(url, {
                method: 'POST',
                body: pdfBase64,
                headers: { 'Content-Type': 'text/plain' }
            });
            return response.text();
        } catch (error) {
            console.error('erro', error);
            throw new Error('Erro ao carregar o assinador. Verifique a instalação do Shodo e tente novamente.', {
                cause: error
            });
        }
    }

    async recuperarDocumentosParaAssinatura(
        processosAssinatura,
        idSessao,
        orgaoJudicante,
        tipoJulgamentoSessao,
        tratamentoErroComponente = false
    ) {
        const resposta = await this.fetchConfig({
            url: `${this.configuracao.urlSessoes + idSessao}/certidoes-julgamento/informacoes-para-assinatura?siglaOjc=${orgaoJudicante.sigla}&nomeOjc=${orgaoJudicante.descricao}&tipoJulgamentoSessao=${tipoJulgamentoSessao}`,
            method: 'POST',
            data: processosAssinatura,
            addHeader: [{ parametro: 'Content-type', valor: 'application/json' }],
            tratamentoErroComponente: tratamentoErroComponente
        });

        return resposta;
    }

    async salvarAssinaturas(
        assinaturas,
        idSessao,
        tipoJulgamentoSessao,
        cadeiaCertificados,
        tratamentoErroComponente = false
    ) {
        const resposta = await this.fetchConfig({
            url: `${this.configuracao.urlSessoes + idSessao}/certidoes-julgamento/informacoes-assinatura`,
            method: 'POST',
            data: {
                cadeiaCertificadosBase64: cadeiaCertificados,
                assinaturaProcessos: assinaturas,
                tipoJulgamentoSessao: tipoJulgamentoSessao
            },
            tratamentoErroComponente: tratamentoErroComponente
        });

        return resposta;
    }

    async assinarCertidoesOtp(numerosProcessosSessoes, idSessao, tipoJulgamentoSessao, orgaoJudicante, chaveOtp) {
        const resposta = await this.fetchConfig({
            url: `${this.configuracao.urlSessoes + idSessao}/assinatura-certidoes-otp?siglaOjc=${orgaoJudicante.sigla}&nomeOjc=${orgaoJudicante.descricao}`,
            method: 'POST',
            data: {
                encoding: 'UTF-8',
                otp: chaveOtp,
                processos: numerosProcessosSessoes,
                tipoJulgamentoSessao: tipoJulgamentoSessao
            },
            tratamentoErroComponente: true
        });

        return resposta;
    }
}
